const HEADING_ID = 'contact-form';
const SUBJECTS = new Map([
  ['consultation', 'Request a Consultation'],
  ['bid', 'Invite Us to Bid'],
  ['apply', 'Join Our Team'],
]);

export function initializeContactInquiry() {
  const heading = document.getElementById(HEADING_ID);

  if (!heading?.parentElement) {
    return;
  }

  const initializedForms = new WeakSet();
  const initializedSelects = new WeakSet();
  const defaultValues = new WeakMap();

  const initializeForm = ({ restoreDefault = false } = {}) => {
    const form = heading.parentElement.querySelector(
      ':scope > .forminator-ui.forminator-custom-form',
    );

    if (!form) return;

    const syncSelect = () => {
      const select = form.querySelector('select[name="select-1"]');
      const combobox = form.querySelector(
        '#select-1 .select2-selection[role="combobox"]',
      );

      select?.setAttribute('aria-labelledby', HEADING_ID);
      combobox?.setAttribute('aria-labelledby', HEADING_ID);

      if (!select) return;

      const isNewSelect = !initializedSelects.has(select);
      if (isNewSelect) {
        initializedSelects.add(select);
        defaultValues.set(select, select.value);
      }

      const subject = SUBJECTS.get(
        new URLSearchParams(window.location.search).get('subject'),
      );
      const value =
        subject ?? (restoreDefault ? defaultValues.get(select) : null);
      if (
        (!isNewSelect && !restoreDefault) ||
        !value ||
        select.value === value ||
        !Array.from(select.options).some((option) => option.value === value)
      ) {
        return;
      }

      select.value = value;

      select.dispatchEvent(new Event('change', { bubbles: true }));
    };

    syncSelect();

    if (initializedForms.has(form)) return;
    initializedForms.add(form);

    // Forminator can replace the Select2 control when it initializes or redraws.
    const observer = new MutationObserver(syncSelect);
    observer.observe(form, { childList: true, subtree: true });
  };

  initializeForm();
  const syncNavigation = () => initializeForm({ restoreDefault: true });
  window.addEventListener('popstate', syncNavigation);
  const observer = new MutationObserver(initializeForm);
  observer.observe(heading.parentElement, { childList: true });
}
